export default "__VITE_ASSET__e3da64c4__"